module.exports = __webpack_public_path__ + "static/media/mayoreo.fe93ef73.png";